import { Component, Mixins } from 'vue-property-decorator';
import Props from './props';

@Component
export default class CalendarText extends Mixins(Props) {
  // Computed
  get classes() {
    return `page-calendar-text_${this.variant}`;
  }
}



// WEBPACK FOOTER //
// ./src/components/calendar/text/script.ts